module.exports = __webpack_public_path__ + "static/media/G__Logo.7f4ab22d.png";


//////////////////
// WEBPACK FOOTER
// ./src/component/images/G__Logo.png
// module id = 690
// module chunks = 0